module.exports = __webpack_public_path__ + "static/media/Oct_2025_1.e5b6ef4c.webp";